import { render } from "./ModuleLandingPage.vue?vue&type=template&id=4c2df76f"
import script from "./ModuleLandingPage.vue?vue&type=script&lang=js"
export * from "./ModuleLandingPage.vue?vue&type=script&lang=js"

import "./ModuleLandingPage.vue?vue&type=style&index=0&id=4c2df76f&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__